import { Immutable } from "immer";
import React from "react";

import styles from "./index.module.scss";

export const OrderConfirmationFooter = (
    props: Immutable<{ children: React.ReactNode }>,
): React.JSX.Element => {
    return (
        <div className={styles.orderConfirmationFooter}>{props.children}</div>
    );
};
